import {GridToolbarContainer} from '@mui/x-data-grid';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import CustomGridToolbarQuickFilter from '../CustomGridToolbarQuickFilter';
import { StyledDataGrid } from '../../../components/StyledComponents';
import CustomPagination from '../CustomPagination';
import { Tooltip } from '@mui/material';
import DeleteIcon16pxSvg from '../../../assets/images/icons/DeleteIcon16pxSvg';
import EditNew20pxSvg from '../../../assets/images/icons/EditNew20pxSvg';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import HolidayApi from './../../../axios/LeaveAndHoliday/HolidayApi';
import { toast } from 'react-toastify';
import { useSettings } from '../../../context/SettingsContext';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useAuth } from '../../../context/AuthContext';
import dayjs from 'dayjs';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import { useLoading } from '../../../context/LoadingContext';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const HolidaysGridInfoTable = (props) => {
  const { dateTimeFormat, page, pageSize, setPage, setPageSize, refreshData, onRowSelection, selectedDate, handleGetCountData, genaralSettingDateFormat, externalQuickFilter = '', hideToolbar = false, dialogRef } = props
  const [show, hide] = useLoading();
  const { getHolidayList } = HolidayApi()
  const { t } = useTranslation();
  const { profile, genaralSettingTimeZone, isAdmin, isEmployee } = useAuth();
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);

  const toDayjsFormat = (format) =>
    format
      .replace(/dd/g, "DD")
      .replace(/MM/g, "MM")
      .replace(/yyyy/g, "YYYY");

  const columnData = useMemo(
    () => [
      { field: 'description', headerName: t('common.description'), minWidth: 150 },
      {
        field: 'startDateEffective',
        headerName: t('common.start-date'),
        flex: 1,
        valueFormatter: (value) =>
          value
            ? dayjs
              .utc(value)
              .utcOffset(genaralSettingTimeZone)
              .format(toDayjsFormat(genaralSettingDateFormat))
            : "-",

      },
      {
        field: 'endDateEffective',
        headerName: t('common.end-date'),
        flex: 1,
        valueFormatter: (value) =>
          value
            ? dayjs
              .utc(value)
              .utcOffset(genaralSettingTimeZone)
              .format(toDayjsFormat(genaralSettingDateFormat))
            : "-",

      },

      ...(isAdmin ? [{
        field: 'option',
        headerName: t('common.options'),
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
          const holidayPayload = {
            isHolidayRecurring: params.row.isHolidayRecurring,
            startDate: params.row.startDate,
            endDate: params.row.endDate,
            recurringType: params.row.recurringType,
            recurringDay: params.row.recurringDay,
            recurringMonth: params.row.recurringMonth,
            description: params.row.description,
            holidayId: Number(params.row.holidayId),
            startDateEffective: params.row.startDateEffective,
            endDateEffective: params.row.endDateEffective,
          };
          const iconBtnClass =
            "inline-flex items-center justify-center w-8 h-8 shrink-0 rounded-lg hover:bg-gray-100 transition cursor-pointer p-0";

          return (
            <div
              className="flex flex-nowrap items-center justify-center gap-1 h-full w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <Tooltip title={t('button.edit')} arrow>
                <button
                  type="button"
                  className={iconBtnClass}
                  onClick={() => dialogRef?.current?.openEditHoliday?.(holidayPayload)}
                >
                  <EditNew20pxSvg width={20} height={20} />
                </button>
              </Tooltip>
              <Tooltip title={t('button.delete')} arrow>
                <button
                  type="button"
                  className={`${iconBtnClass} hover:bg-red-100`}
                  onClick={() => dialogRef?.current?.openDeleteHoliday?.(holidayPayload)}
                >
                  <DeleteIcon16pxSvg width={20} height={20} color="#D00D00" />
                </button>
              </Tooltip>
            </div>
          );
        },
      }] : []),
    ],
    [t, dateTimeFormat, isAdmin, dialogRef]
  );

  const [rowData, setRowData] = useState([]);
  const [gridLoading, ] = useState(false)
  const [, setSelectedRowId] = useState(null);
  const [, setTotalPages] = useState(1);
  const [rowCount, setRowCount] = useState(0)
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [filteredRowCount, setFilteredRowCount] = useState(0);

  const defaultColumnVisibility = {
    startDate: true,
    description: true,
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(defaultColumnVisibility);

  const CustomToolbar = useCallback(
    () => (
      <div>
        <GridToolbarContainer className="flex justify-between items-center mb-3">
          <div className="flex gap-3">
            {/* <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector /> */}
          </div>
            <CustomGridToolbarQuickFilter fullWidth />
        </GridToolbarContainer>
      </div>
    ),
    [t]
  );

  const getFromToByDateWithTZ = (date, timeZone) => {
    const offset = timeZone || "+00:00";
    const base = dayjs(date).utcOffset(offset, true);

    return {
      from: base.startOf("day").utc().toISOString(),
      to: base.endOf("day").utc().toISOString(),
    };
  };


  const fetchData = async () => {
    show();
    try {
      const { from, to } = getFromToByDateWithTZ(selectedDate, genaralSettingTimeZone);

      const response = await getHolidayList(
        page + 1,
        pageSize,
        from,
        to,
        localStorage.getItem("i18nextLngId")
      );

      if (response.data.message === "Successful" || response.data.message === "Thành công") {
        setTotalPages(parseInt(response.headers['total_pages']));
        setRowCount(parseInt(response.headers['total_records']));

        const holidayList = response.data.data || [];

        setRowData(
          holidayList.map(holiday => ({
            ...holiday,
            holidayId: Number(holiday.holidayId),
          }))
        );

        handleGetCountData(holidayList.length);
        setFilteredRowData(
          holidayList.map(holiday => ({
            ...holiday,
            holidayId: Number(holiday.holidayId),
          }))
        );
        setFilteredRowCount(response.data.pagination.totalElements);


        if (holidayList.length > 0) {
          const firstRow = holidayList[0];
          setSelectedRowId(Number(firstRow.holidayId));
          onRowSelection({
            isHolidayRecurring: firstRow.isHolidayRecurring,
            startDate: firstRow.startDate,
            endDate: firstRow.endDate,
            recurringType: firstRow.recurringType,
            recurringDay: firstRow.recurringDay,
            recurringMonth: firstRow.recurringMonth,
            description: firstRow.description,
            holidayId: Number(firstRow.holidayId),
            startDateEffective: firstRow.startDateEffective,
            endDateEffective: firstRow.endDateEffective,
          });
        } else {
          onRowSelection?.({});
        }
      }
    } catch (error) {
      if (error.response && error.response.status !== 401) {
        toast.error(t(error?.response.data));
      }
      console.error('Error fetching data:', error);
    } finally {
      hide();
    }
  };

  useEffect(() => {
    // setLoading(true)
    const timeoutId = setTimeout(() => {
      fetchData();
      // setLoading(false)
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [page, pageSize, refreshData, selectedDate, show, hide]);

  useEffect(() => {
    if (!externalQuickFilter?.trim()) {
      setFilteredRowData(rowData);
      return;
    }
    const lowerSearch = externalQuickFilter.trim().toLowerCase();
    const filtered = rowData.filter((row) =>
      Object.values(row).some((val) => String(val).toLowerCase().includes(lowerSearch))
    );
    setFilteredRowData(filtered);
  }, [externalQuickFilter, rowData, rowCount]);

  const emailUser = profile?.email;

  useEffect(() => {
    const saved = Cookies.get(`HolidaysGridInfoTable_${emailUser}`);
    if (saved) {
      setColumnVisibilityModel(JSON.parse(saved));
    }
  }, [emailUser]);

  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    Cookies.set(`HolidaysGridInfoTable_${emailUser}`, JSON.stringify(newModel), {
      expires: 90,
      path: '/',
    });
  };

  const hasRows = filteredRowData.length > 0;
  const gridHeight = hasRows ? 440 : 440;

  const onRowsSelectionHandler = (newSelection) => {
    const selectedId = newSelection[0];
    const selectedRow = rowData.find(
      (row) => Number(row.holidayId) === Number(selectedId)
    );

    if (selectedRow) {
      onRowSelection((prev) => ({
        ...prev,
        isHolidayRecurring: selectedRow.isHolidayRecurring,
        startDate: selectedRow.startDate,
        endDate: selectedRow.endDate,
        recurringType: selectedRow.recurringType || '',
        recurringDay: selectedRow.recurringDay || '',
        recurringMonth: selectedRow.recurringMonth || '',
        description: selectedRow.description,
        holidayId: Number(selectedRow.holidayId),
      }));
    }
  };

  return (
    <div className="w-full min-w-0 max-w-full overflow-hidden">
      <div className={`w-full max-w-full ${hasRows ? 'overflow-x-auto' : 'overflow-x-hidden'}`}>
        <StyledDataGrid
          sx={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            height: gridHeight,
            '& .MuiDataGrid-scrollbar--vertical': {
              display: 'none !important',
            },
            '& .MuiDataGrid-scrollbar--horizontal': {
              display: hasRows ? undefined : 'none !important',
            },
            '& .MuiDataGrid-virtualScroller': {
              overflow: hasRows ? 'auto !important' : 'hidden !important',
            },
            '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
              display: hasRows ? undefined : 'none !important',
            },
          }}
          rows={filteredRowData}
          rowCount={filteredRowCount}
          paginationMode="client"
          columns={columnData}
          loading={gridLoading}
          getRowId={(r) => r.holidayId}
          ignoreDiacritics
          slots={{
            toolbar: hideToolbar ? undefined : CustomToolbar,
            pagination: CustomPagination,
            noRowsOverlay: NoRowOverlay,
            columnsPanel: CustomColumnsPanel,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
            pagination: {
              page,
              count: filteredRowCount,
              rowsPerPage: pageSize,
              onPageChange: setPage,
              onRowsPerPageChange: setPageSize,
            },
          }}
          onRowSelectionModelChange={onRowsSelectionHandler}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
          localeText={tableTranslated}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterValues: [''],
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default HolidaysGridInfoTable